<template>
  <router-view ref="statusBar" name="statusBar" />
</template>
<script>
export default {
  name: 'AccountStatusBarWrapper',
};
</script>

<style>
/*use src/assets/scss/components/status-bar.scss*/
</style>
